import _defineProperty from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { HTMLElement, h, Host, proxyCustomElement } from '@stencil/core/internal/client';
import { b as getIonMode } from './ionic-global.js';
import { c as createColorClasses } from './theme.js';
var cardTitleIosCss = ":host{display:block;position:relative;color:var(--color)}:host(.ion-color){color:var(--ion-color-base)}:host{--color:var(--ion-text-color, #000);margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;font-size:28px;font-weight:700;line-height:1.2}";
var cardTitleMdCss = ":host{display:block;position:relative;color:var(--color)}:host(.ion-color){color:var(--ion-color-base)}:host{--color:var(--ion-color-step-850, #262626);margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;font-size:20px;font-weight:500;line-height:1.2}";

var CardTitle = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CardTitle, _HTMLElement);

  var _super = _createSuper(CardTitle);

  function CardTitle() {
    var _this;

    _classCallCheck(this, CardTitle);

    _this = _super.call(this);

    _this.__registerHost();

    _this.__attachShadow();

    return _this;
  }

  _createClass(CardTitle, [{
    key: "render",
    value: function render() {
      var mode = getIonMode(this);
      return h(Host, {
        role: "heading",
        "aria-level": "2",
        class: createColorClasses(this.color, _defineProperty({
          'ion-inherit-color': true
        }, mode, true))
      }, h("slot", null));
    }
  }], [{
    key: "style",
    get: function get() {
      return {
        ios: cardTitleIosCss,
        md: cardTitleMdCss
      };
    }
  }]);

  return CardTitle;
}(HTMLElement);

CardTitle = /*@__PURE__*/proxyCustomElement(CardTitle, [33, "ion-card-title", {
  "color": [513]
}]);

function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }

  var components = ["ion-card-title"];
  components.forEach(function (tagName) {
    switch (tagName) {
      case "ion-card-title":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, CardTitle);
        }

        break;
    }
  });
}

var IonCardTitle = CardTitle;
var defineCustomElement = defineCustomElement$1;
export { IonCardTitle, defineCustomElement };